import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=3e5d9aee&scoped=true&"
import script from "./productCard.vue?vue&type=script&lang=js&"
export * from "./productCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d9aee",
  null
  
)

export default component.exports